import { truthy } from '../../utils';
import type { State } from '../types';

/**
 * this is required to get the available addons for the selected offerings
 * this is used to show the available addons for the selected offering on cart table
 */
export const getStatuspageAddonsOfferingRelationshipMap = (product: any) => {
  const availableAddonsForOfferingMap: State['statuspageAddonsOfferingsMap'] = {};
  if (!product) {
    return availableAddonsForOfferingMap;
  }
  product?.offering?.forEach((offering: any) => {
    const offeringId = offering?.id;
    const availableAddons = offering?.availableAddOns?.filter(truthy);
    if (offeringId && availableAddons && availableAddons?.length > 0) {
      /**
       * this is required to map available addons for the statuspage offerings
       * For example,
       * if the offeringId is "Public enterprises" and the available addons are ["Subscribers", "Metrics", "Team members"]
       * if the offeringId is "Audience specific" and the available addons are ["Page viewer SSO"]
       */
      availableAddonsForOfferingMap[offeringId] = availableAddons;
    }
  });
  return availableAddonsForOfferingMap;
};
